import { getbulkDraggedData } from './getBulkDraggedData';

export const getNewDraggedData = ({ source, destination, structure, bulkDrag, setBulkDrag }: any) => {
  const { droppableId: sourceDroppableId } = source;
  const { droppableId: destinationDroppableId } = destination;
  let indexOfSources = getArrayFromString(sourceDroppableId);
  let indexOfDestination = getArrayFromString(destinationDroppableId);

  const invalidDrag = indexOfSources[0] === 'week' || indexOfSources[0] === 'phase';
  const invalidDrop = indexOfDestination[0] === 'phase';

  if (invalidDrag || invalidDrop) {
    return structure;
  }

  if (indexOfSources[1] === 'bulk') {
    return getbulkDraggedData({
      bulkDrag,
      indexOfSources,
      indexOfDestination,
      structure,
      setBulkDrag,
    });
  }

  const isSubjectExist = checkSubjectExistOrNot({
    indexOfSources,
    indexOfDestination,
    structure,
  });
  let indexOfSourceForDestination: any;
  const { isSubjectExistForConcept, subjectData } = checkSubjectOfConceptExistOrNot({
    indexOfSources,
    indexOfDestination,
    structure,
  });
  const comingFromWhere = indexOfSources[0];
  indexOfSources = indexOfSources.slice(1);
  indexOfDestination = indexOfDestination.slice(1);
  const cloneStructure = JSON.parse(JSON.stringify(structure));
  const { phases = [] } = cloneStructure;
  let sourceDataForConcept: any = {};
  let sourceDataKey = '';
  let sourceDataIndex = [];
  let removableName = '';
  let clonePhases = JSON.parse(JSON.stringify(phases));
  let checkForRemovePhaseDataFromPhase = {
    isPhaseRemovable: false,
    phaseId: '',
  };
  let checkForWeekRemoveFromPhase = {
    isWeekRemove: false,
    weekId: '',
    phaseIndex: 0,
  };
  let chapterRemoveFromPhase = {
    isChapterRemove: false,
    chapterName: '',
    weekIndex: 0,
    phaseIndex: 0,
    subjectIndex: 0,
  };

  let conceptRemovePhase = {
    isConceptRemove: false,
    conceptName: '',
    subjectIndex: 0,
    chapterIndex: 0,
    conceptIndex: 0,
    weekIndex: 0,
    phaseIndex: 0,
  };
  let resetPhases = JSON.parse(JSON.stringify(phases));

  //
  let phase = getPhase(indexOfSources, phases);
  let week = getWeek(indexOfSources, phases);
  let subjects = getSubjectsArray(indexOfSources, phases);
  let sourceData = getSubjectObject(indexOfSources, phases);
  let subject = sourceData;
  let indexOfPhases = Number(indexOfSources[0]);
  let indexOfWeeks = Number(indexOfSources[1]);
  let indexOfSubject = Number(indexOfSources[2]);
  let indexOfChapter = Number(indexOfSources[3]);
  let chapter = subject.chapters[Number(indexOfSources[3])];
  let resetPhase = resetPhases[indexOfPhases];
  let resetWeeks = resetPhase.weeks;
  let resetWeek = resetWeeks[indexOfWeeks];
  let resetSubjects = resetWeek.subjects;
  let resetSubject = resetSubjects[indexOfSubject];
  let resetChapters = resetSubject.chapters;
  //

  if (comingFromWhere === 'chapter') {
    if (isSubjectExist) {
      const checkChapterExist = checkChapterExistInSubject(indexOfDestination, phases, chapter);
      if (checkChapterExist) {
        const getNewChapter = mergeSameChapter(indexOfDestination, phases, chapter);
        if (Object.keys(getNewChapter).length) {
          removableName = getNewChapter.name;
          sourceData = { ...sourceData, chapters: [{ ...getNewChapter }] };
        }
      } else {
        sourceDataForConcept = { ...sourceData, chapters: [{ ...chapter }] };
        sourceData = { ...sourceData, chapters: [{ ...chapter }] };
        sourceDataKey = '';

        resetChapters = resetChapters.filter((ele: any) => chapter.name !== ele.name);
        chapterRemoveFromPhase.isChapterRemove = true;
        chapterRemoveFromPhase.weekIndex = indexOfWeeks;
        chapterRemoveFromPhase.subjectIndex = indexOfSubject;
        chapterRemoveFromPhase.phaseIndex = indexOfPhases;
        chapterRemoveFromPhase.chapterName = chapter.name;
        if (!resetChapters.length) {
          resetSubjects = subjects.filter((ele: any) => ele.name !== subject.name);
          if (!resetSubjects.length) {
            checkForWeekRemoveFromPhase.isWeekRemove = true;
            checkForWeekRemoveFromPhase.weekId = week._id;
            checkForWeekRemoveFromPhase.phaseIndex = indexOfPhases;
            resetWeeks = phase.weeks.filter((ele: any) => ele._id !== week._id);
            if (!resetWeeks.length) {
              checkForRemovePhaseDataFromPhase.isPhaseRemovable = true;
              checkForRemovePhaseDataFromPhase.phaseId = phase._id;
            }
          }
        }
      }
    } else {
      sourceData = { ...sourceData, chapters: [{ ...chapter }] };
      sourceDataForConcept = { ...sourceData, chapters: [{ ...chapter }] };
      sourceDataKey = '';
      resetChapters = subject.chapters.filter((ele: any) => chapter.name !== ele.name);
      chapterRemoveFromPhase.isChapterRemove = true;
      chapterRemoveFromPhase.weekIndex = indexOfWeeks;
      chapterRemoveFromPhase.subjectIndex = indexOfSubject;
      chapterRemoveFromPhase.phaseIndex = indexOfPhases;
      chapterRemoveFromPhase.chapterName = chapter.name;
      if (!resetChapters.length) {
        subjects.filter((ele: any) => ele.name !== subject.name);
        if (!resetSubjects.length) {
          resetWeeks = phase.weeks.filter((ele: any) => ele._id !== week._id);
          checkForWeekRemoveFromPhase.isWeekRemove = true;
          checkForWeekRemoveFromPhase.weekId = week._id;
          checkForWeekRemoveFromPhase.phaseIndex = indexOfPhases;
          if (!resetWeeks.length) {
            checkForRemovePhaseDataFromPhase.isPhaseRemovable = true;
            checkForRemovePhaseDataFromPhase.phaseId = phase._id;
          }
        }
      }
    }
  }
  const { concepts = [] } = chapter;
  Number(indexOfSources[4]) >= 0 &&
    concepts.forEach((concept: any, indexOfConcept: number) => {
      if (indexOfConcept === Number(indexOfSources[4])) {
        if (isSubjectExistForConcept && comingFromWhere === 'concept') {
          let checkConcept = checkChapterExistForConcept(indexOfDestination, phases, chapter);
          if (!checkConcept) {
            subjectData['chapters'][indexOfChapter]['concepts'] = [{ ...concept }];
            indexOfSourceForDestination = indexOfChapter;
            sourceData = JSON.parse(JSON.stringify(subjectData));
            sourceDataKey = 'concepts';
          } else {
            checkConcept.concepts.push(concept);
            subjectData['chapters'][indexOfChapter] = { ...checkConcept };
            sourceData = JSON.parse(JSON.stringify(subjectData));
            indexOfSourceForDestination = indexOfChapter;
            sourceDataKey = 'concepts';
          }
          // for deleting data of concept
          if (resetChapters[indexOfChapter]['concepts'].length === 1) {
            chapterRemoveFromPhase.isChapterRemove = true;
            chapterRemoveFromPhase.weekIndex = indexOfWeeks;
            chapterRemoveFromPhase.subjectIndex = indexOfSubject;
            chapterRemoveFromPhase.phaseIndex = indexOfPhases;
            chapterRemoveFromPhase.chapterName = chapter.name;
            resetChapters = subject.chapters.filter((ele: any) => ele.name !== chapter.name);
            if (!resetChapters) {
              resetSubjects = subjects.filter((ele: any) => resetSubject.id !== ele.id);
              if (!resetSubjects.length) {
                checkForWeekRemoveFromPhase.isWeekRemove = true;
                checkForWeekRemoveFromPhase.weekId = week._id;
                checkForWeekRemoveFromPhase.phaseIndex = indexOfPhases;
                resetWeeks = phase.weeks.filter((ele: any) => ele._id !== week._id);
                if (!resetWeeks.length) {
                  checkForRemovePhaseDataFromPhase.isPhaseRemovable = true;
                  checkForRemovePhaseDataFromPhase.phaseId = phase._id;
                }
              }
            }
          } else {
            conceptRemovePhase.isConceptRemove = true;
            conceptRemovePhase.subjectIndex = indexOfSubject;
            conceptRemovePhase.conceptIndex = indexOfConcept;
            conceptRemovePhase.chapterIndex = indexOfChapter;
            conceptRemovePhase.weekIndex = indexOfWeeks;
            conceptRemovePhase.phaseIndex = indexOfPhases;
            conceptRemovePhase.conceptName = concept.name;
            resetChapters[indexOfChapter]['concepts'] = chapter.concepts.filter(
              (ele: any) => ele.name !== concept.name
            );
          }
        } else {
          // this can couse trouble remove after debugging
          if (isSubjectExist) {
            sourceData = '';
            sourceDataKey = '';
          } else {
            let newSourceData = JSON.parse(JSON.stringify(sourceDataForConcept));
            newSourceData['chapters'][indexOfChapter]['concepts'] = [{ ...concept }];
            sourceData = JSON.parse(JSON.stringify(newSourceData));
            sourceDataKey = '';
          }
        }
      }
    });

  phase = getPhase(indexOfDestination, phases);
  week = getWeek(indexOfDestination, phases);
  indexOfPhases = Number(indexOfDestination[0]);
  indexOfWeeks = Number(indexOfDestination[1]);
  indexOfSubject = Number(indexOfDestination[2]);
  subjects = getSubjectsArray(indexOfDestination, phases);

  let children: any = [];
  subjects.forEach((ele: any) => ele.chapters.forEach((element: any) => children.push(element)));
  if (comingFromWhere === 'chapter') {
    if (isSubjectExist) {
      let cloneSubjects: any = {};

      subjects.forEach((subject: any) => {
        if (subject.id === sourceData.id) {
          cloneSubjects = JSON.parse(JSON.stringify(subject));
        }
      });

      cloneSubjects['chapters'] = cloneSubjects['chapters'].filter((ele: any) => ele.name !== removableName);
      cloneSubjects['chapters'] = [...cloneSubjects['chapters'], ...sourceData['chapters']];
      clonePhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'] = clonePhases[indexOfPhases]['weeks'][indexOfWeeks][
        'subjects'
      ].filter((ele: any) => ele.id !== sourceData.id);

      clonePhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'].push(cloneSubjects);
    } else {
      clonePhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'].push(sourceData);
    }
  }
  if (comingFromWhere === 'concept') {
    let conceptData: any = [];
    let chapterData: any = [];
    clonePhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'].map(
      (ele: any) =>
        ele.id === sourceData.id &&
        ele.chapters.forEach((ele: any) => {
          chapterData.push(ele);
          sourceData['chapters'][0].name === ele.name && ele.concepts.forEach((ele: any) => conceptData.push(ele));
        })
    );
    chapterData = chapterData.filter(
      (ele: any) => ele.name !== sourceData['chapters'][indexOfSourceForDestination].name
    );
    chapterData &&
      chapterData.length &&
      (sourceData['chapters'] = [
        { ...sourceData['chapters'][indexOfSourceForDestination] },
        ...JSON.parse(JSON.stringify(chapterData)),
      ]);
    clonePhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'] = clonePhases[indexOfPhases]['weeks'][indexOfWeeks][
      'subjects'
    ].filter((ele: any) => ele.name !== sourceData.name);
    clonePhases[indexOfPhases]['weeks'][indexOfWeeks]['subjects'].push(sourceData);
  }

  if (checkForRemovePhaseDataFromPhase.isPhaseRemovable) {
    clonePhases = clonePhases.filter((ele: any) => ele._id !== checkForRemovePhaseDataFromPhase.phaseId);
  }
  if (!checkForRemovePhaseDataFromPhase.isPhaseRemovable && checkForWeekRemoveFromPhase.isWeekRemove) {
    clonePhases[checkForWeekRemoveFromPhase.phaseIndex]['weeks'] = clonePhases[checkForWeekRemoveFromPhase.phaseIndex][
      'weeks'
    ].filter((ele: any) => ele._id !== checkForWeekRemoveFromPhase.weekId);
  }
  if (
    !checkForRemovePhaseDataFromPhase.isPhaseRemovable &&
    !checkForWeekRemoveFromPhase.isWeekRemove &&
    chapterRemoveFromPhase.isChapterRemove
  ) {
    const { chapterName, phaseIndex, subjectIndex, weekIndex } = chapterRemoveFromPhase;
    clonePhases[phaseIndex]['weeks'][weekIndex]['subjects'][subjectIndex]['chapters'] = clonePhases[phaseIndex][
      'weeks'
    ][weekIndex]['subjects'][subjectIndex]['chapters'].filter((ele: any) => ele.name !== chapterName);
  }
  if (
    !checkForRemovePhaseDataFromPhase.isPhaseRemovable &&
    !checkForWeekRemoveFromPhase.isWeekRemove &&
    !chapterRemoveFromPhase.isChapterRemove &&
    conceptRemovePhase.isConceptRemove
  ) {
    const { subjectIndex, conceptName, phaseIndex, chapterIndex, weekIndex } = conceptRemovePhase;
    clonePhases[phaseIndex]['weeks'][weekIndex]['subjects'][subjectIndex]['chapters'][chapterIndex][
      'concepts'
    ] = clonePhases[phaseIndex]['weeks'][weekIndex]['subjects'][subjectIndex]['chapters'][chapterIndex][
      'concepts'
    ].filter((ele: any) => ele.name !== conceptName);
  }
  let finalStatus = JSON.parse(JSON.stringify(structure));
  finalStatus = { ...finalStatus, phases: JSON.parse(JSON.stringify(clonePhases)) };
  return finalStatus;
};

const getArrayFromString = (ids: string) => {
  let totalRequiredIndex = 6;
  let arrayOfIndex = ids.split('-');
  for (let i = arrayOfIndex.length; i < totalRequiredIndex; i++) {
    arrayOfIndex.push('-1');
  }
  return arrayOfIndex;
};

const checkSubjectExistOrNot = ({ indexOfSources, indexOfDestination, structure }: any) => {
  const { phases = [] } = structure;
  const subjectData = getSubjectObject(indexOfSources, phases);
  const destinationSubjects = getSubjectsArray(indexOfDestination, phases);
  for (const sub of destinationSubjects)
    if (sub.name === subjectData.name) {
      return true;
    }
  return false;
};

const checkSubjectOfConceptExistOrNot = ({ indexOfSources, indexOfDestination, structure }: any) => {
  let cloneStructure = JSON.parse(JSON.stringify(structure));
  const { phases = [] } = cloneStructure;
  const subjectData = getSubjectObject(indexOfSources, phases);
  let isSubjectExistForConcept = checkSubjectExistOrNot({ indexOfSources, indexOfDestination, structure });
  return { isSubjectExistForConcept, subjectData };
};

const checkChapterExistForConcept = (indexOfDestination: any, phases: any, chapter: any) => {
  let getConcept: any = {};
  let allChapters: any = [];
  const subjects = getSubjectsArray(indexOfDestination, phases);

  subjects.forEach((ele: any) => ele.chapters.forEach((ele: any) => allChapters.push(ele)));

  getConcept = allChapters.find((ele: any) => ele.name === chapter.name);
  return getConcept;
};

const checkChapterExistInSubject = (indexOfDestination: any, phases: any, chapter: any) => {
  const subjects = getSubjectsArray(indexOfDestination, phases);

  for (const subject of subjects) {
    for (const chap of subject.chapters) {
      if (chap.name === chapter.name) {
        return true;
      }
    }
  }
  return false;
};

const mergeSameChapter = (indexOfDestination: any, phases: any, chapter: any) => {
  let getConcept: any = {};
  let allChapters: any = [];
  const subjects = getSubjectsArray(indexOfDestination, phases);
  subjects.forEach((ele: any) => ele.chapters.forEach((ele: any) => allChapters.push(ele)));

  getConcept = allChapters.find((ele: any) => ele.name === chapter.name);
  if (getConcept && Object.keys(getConcept).length) {
    chapter.concepts.forEach((ele: any) => {
      getConcept.concepts.push(ele);
    });
    return getConcept;
  }

  // implement logic to remove chapter from source
  return getConcept;
};

const getPhase = (indices: any, phases: any) => {
  const isSpliced = indices[0].length === 1;

  if (isSpliced) {
    return phases[Number(indices[0])];
  }
  return phases[Number(indices[1])];
};

const getWeek = (indices: any, phases: any) => {
  const phase = getPhase(indices, phases);
  const isSpliced = indices[0].length === 1;

  if (isSpliced) {
    return phase.weeks[Number(indices[1])];
  }
  return phase.weeks[Number(indices[2])];
};

const getSubjectsArray = (indices: any, phases: any) => {
  const week = getWeek(indices, phases);
  const subjectsArray = week.subjects;
  return subjectsArray;
};

const getSubjectObject = (indices: any, phases: any) => {
  const subjectsArray = getSubjectsArray(indices, phases);
  const isSpliced = indices[0].length === 1;

  if (isSpliced) {
    return subjectsArray[Number(indices[2])];
  }
  return subjectsArray[Number(indices[3])];
};
